import React from "react";

// Themed image: grayscale + warm sand/terracotta duotone tint,
// matched to the "Organics & Artsy" palette. Wraps <img> in a
// container that layers a terracotta multiply + sand overlay
// on top of a grayscaled+sepia base.
export const ThemedImage = ({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  intensity = "normal", // 'soft' | 'normal' | 'strong'
}) => {
  const tint =
    intensity === "strong"
      ? { rgba: "rgba(201,90,59,0.35)", sand: "rgba(244,241,235,0.18)" }
      : intensity === "soft"
      ? { rgba: "rgba(201,90,59,0.14)", sand: "rgba(244,241,235,0.08)" }
      : { rgba: "rgba(201,90,59,0.22)", sand: "rgba(244,241,235,0.12)" };

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover object-[center_18%] ${imgClassName}`}
        style={{ filter: "grayscale(100%) sepia(28%) contrast(0.96) brightness(0.98)" }}
      />
      <div
        className="pointer-events-none absolute inset-0 mix-blend-multiply"
        style={{ backgroundColor: tint.rgba }}
      />
      <div
        className="pointer-events-none absolute inset-0 mix-blend-overlay"
        style={{ backgroundColor: tint.sand }}
      />
    </div>
  );
};
